import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import ChangeDialogStatusDialog from "~/operatorApplication/vue/dialogs/dialog/sidemenu/ChangeDialogStatusDialog.vue";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "OperatorApplicationMarkClientAsHaveNoAnswerDialog"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    userdata: {}
  }, {
    "visible": { type: Boolean },
    "visibleModifiers": {},
  }),
  emits: ["update:visible"],
  setup(__props: any) {

let props = __props;

let isVisible = _useModel<boolean>(__props, "visible");


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ChangeDialogStatusDialog, {
    userdata: __props.userdata,
    "status-id": _unref(OperatorAccountStore).data.value.standartDialogStatusList.haveNoAnswer,
    visible: _unref(isVisible),
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isVisible) ? (isVisible).value = $event : isVisible = $event))
  }, null, 8, ["userdata", "status-id", "visible"]))
}
}

})